import script from "./DocItemField.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemField.vue?vue&type=script&setup=true&lang=js"

import "./DocItemField.vue?vue&type=style&index=0&id=877146ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-877146ae"]])

export default __exports__